module.exports = __webpack_public_path__ + "img/mbBanner11.552f89a2.png";